
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"id-28a","d":"M12.574 5.244a.837.837 0 011.181 0 .832.832 0 010 1.179L9 11.167 4.245 6.423a.832.832 0 010-1.179.837.837 0 011.18 0L9 8.81l3.574-3.566z"}})]),_c('use',{attrs:{"fill-rule":"evenodd","transform":"rotate(-90 9 8.083)","xlink:href":"#id-28a"}})])
          )
        }
      }
    